import { Toaster as HotToaster } from 'react-hot-toast'
import Lottie from 'lottie-react'
import styled from 'styled-components'

import spinnerAnimation from 'src/lottie-animations/spinner.json'
import errorAnimation from 'src/lottie-animations/cross.json'
import successAnimation from 'src/lottie-animations/check.json'

const Toaster = () => {
	return (
		<HotToaster toastOptions={toastOptions} containerStyle={containerStyle} />
	)
}

const defaultLottieStyleProps = {
	width: 30,
	height: 30,
	color: 'white',
}

const CustomLoadingContainer = styled.div`
	display: flex;
	flex-direction: column;
	gap: 10px;
	align-items: center;
`

const UpdatingContainer = styled.div`
	display: flex;
	align-items: center;
	gap: 20px;
`

const Instructions = styled.div`
	text-align: center;
	font-family: 'Gotham';
	font-size: 16px;
`

export const Backdrop = styled.div`
	background: rgba(0, 0, 0, 0.5);
	position: absolute;
	top: 0;
	left: -400px;
	bottom: 0;
	right: 0;
	z-index: 1000;
`

export const TOAST_DURATION = 2000

const getCustomToast = (title, description, { animationData, loop = true }) => (
	<CustomLoadingContainer>
		<UpdatingContainer>
			<Lottie
				animationData={animationData}
				loop={loop}
				style={defaultLottieStyleProps}
			/>
			{title}
		</UpdatingContainer>
		{description && (
			<Instructions>
				{description}
			</Instructions>
		)}
	</CustomLoadingContainer>
)

export const loadingCustomToast = (
	getCustomToast(
		'Updating displays',
		'Look up at the Micromart Smart Store to see the demo video',
		{ animationData: spinnerAnimation },
	)
)

export const promoLoadingCustomToast = (
	getCustomToast(
		'Applying promo',
		'Look up at the Micromart Smart Store to see the promo',
		{ animationData: spinnerAnimation },
	)
)

export const getErrorCustomToast = (error) => {
	const isLocked = error?.message?.includes('locked')
	const title = isLocked ? "Can't update" : 'Error'
	const description = isLocked ? 'Booth currently in use for another demo. Please try again shortly.' : null
	return (
		getCustomToast(
			title,
			description,
			{ animationData: errorAnimation, loop: false },
		)
	)
}

const toastOptions = {
	style: {
		fontSize: 20,
		color: 'white',
		paddingTop: 20,
		paddingBottom: 20,
		paddingLeft: 40,
		paddingRight: 40,
		backgroundColor: '#242424',
		borderRadius: 100,
		maxWidth: 692,
		marginTop: 400,
	},
	loading: {
		icon: null,
	},
	success: {
		style: {
			backgroundColor: '#26A766',
		},
		icon: (
			<Lottie
				animationData={successAnimation}
				style={defaultLottieStyleProps}
				loop={false}
			/>
		),
	},
	error: {
		style: {
			backgroundColor: 'red',
		},
		icon: null,
	},
}

const containerStyle = {
	// top: '50%',
	// left: '50%',
	// transform: 'translate(-50%, -50%)',
	// inset: 'unset',
	// left: 400,
	// top: 400,
	// background: 'rgba(0, 0, 0, 0.6)',
	// top: 0,
	// left: 0,
	// bottom: 0,
	// right: 0,
}

export default Toaster
